<div class="flex fatal-message">
  <button mat-icon-button>
    <mat-icon><img src="assets/svg/icons/cancel_wht-lg.svg"/></mat-icon>
  </button>
  <div class="message">{{ data.message }}</div>
  <div class="dismiss">
    <button mat-icon-button (click)="snackbarRef.dismiss()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
